export function getdata() {
	var obj = {

		headDataI: [{
			title: '序号',
			prop: 'grade',
			width: "100px",
			custom: true,
		}, {
			title: '抵扣项目名称',
			prop: 'title',
			width: "350px",
			custom: true,
		}, {
			title: '份数',
			children: [{
					title: '1',
					prop: 'zzs_9_x_1',
					custom: true,
				}]
		}, {
			title: '金额',
			children: [{
				title: '2',
				prop: 'zzs_9_x_2',
				custom: true,
			}]

		}, {
			title: '税额',
			children: [{
				title: '3',
				prop: 'zzs_9_x_3',
				custom: true,
			}]
		}],
		tableDataI: [{
				grade: '1',
				title: '桥、闸通行费',
				disabledzzs_9_x_1: false,
				disabledzzs_9_x_2: false,
				disabledzzs_9_x_3: false,
				zzs_9_x_1: {
					cellCode: "zzs_9_x_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_9_x_2: {
					cellCode: "zzs_9_x_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_9_x_3: {
					cellCode: "zzs_9_x_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				grade: '2',
				title: '国内旅客运输服务',
				disabledzzs_9_x_1: false,
				disabledzzs_9_x_2: false,
				disabledzzs_9_x_3: false,
				zzs_9_x_1: {
					cellCode: "zzs_9_x_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_9_x_2: {
					cellCode: "zzs_9_x_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_9_x_3: {
					cellCode: "zzs_9_x_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
			},
			{
				grade: '3',
				title: '尚未抵扣完毕的不动产或者不动产在建工程',
				disabledzzs_9_x_1: true,
				disabledzzs_9_x_2: true,
				zzs_9_x_1: {
					cellCode: "zzs_9_x_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_9_x_2: {
					cellCode: "zzs_9_x_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_9_x_3: {
					cellCode: "zzs_9_x_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
			},
			{
				grade: '4',
				title: '固定资产、无形资产、不动产转变用途可以抵扣的进项税额',
				disabledzzs_9_x_1: true,
				disabledzzs_9_x_2: true,
				disabledzzs_9_x_3: false,
				zzs_9_x_1: {
					cellCode: "zzs_9_x_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_9_x_2: {
					cellCode: "zzs_9_x_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_9_x_3: {
					cellCode: "zzs_9_x_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
			},{
				grade: '5',
				title: '合计',
				disabledzzs_9_x_1: true,
				disabledzzs_9_x_2: true,
				disabledzzs_9_x_3: true,
				zzs_9_x_1: {
					cellCode: "zzs_9_x_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_9_x_2: {
					cellCode: "zzs_9_x_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_9_x_3: {
					cellCode: "zzs_9_x_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}
		],

	}
	return obj
}
